import _styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";export const ManualPortfolioPropertiesFormContainer=_styled.div`
  display: flex;
  justify-content: flex-start;
  ${mediaQuery({flexDirection:["column","column","row"]})}
  align-items: stretch;
  column-gap: 16px;
  width: 100%;
`;